import React from 'react';
import "./LoadingScreen.scss";
import loading from "../../assets/loading.svg";
import logo from "../../assets/logo.png";

export default function LoadingScreen(props: any) {
    return (
        <div className="loading-screen">
            <img id="logo-large" alt="StoryChart Logo" src={logo} />
            <img id="loading-indicator" alt="Loading Indicator" src={loading} />
        </div>
    );
}